import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Input, Row, Col } from 'reactstrap';
import HelpIcon from '@material-ui/icons/Help';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Tooltip, Typography, Button, ListItemAvatar } from '@material-ui/core';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails  from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import SystemLabel from '../../../../../../system/SystemLabel/SystemLabel';


export default function PresetOverview(props) {
    const { selectedPreset } = props;
    return (
        <Card className="dark-card" style={{ margin: 10, height: 'calc(100% - 10px)' }}>
            <CardContent style={{ minHeight: 'calc(100% - 40px)', maxHeight: 'calc(100% - 40px)', }}>
                <div className="inline-flex" style={{ width: '100%', padding: '0px', margin: '10px 0px' }}>
                    <Col className="col-7 text-left">
                        <Typography variant="h6" className="primary-text">
                            {selectedPreset ? selectedPreset.name : <SystemLabel name="NoPresetSelected" />}
                        </Typography>
                    </Col>
                    <Col className="col-5 text-right">
                    </Col>
                </div>
                {selectedPreset ? 
                // renderPresetContent(selectedPreset.content) 
                <div style={{color:"white"}}>
                    {selectedPreset.name} <br></br>
                    {'Förhandsgranskning kommer snart'}

                </div>
                : null}
            </CardContent>
        </Card>


    );
}


const renderPresetContent = (content) => {
    const contentInfo = <List>
        {presetCollapse({ icon: <HelpIcon />, label: "ActiveQuestions" }, content.questions, 'questions')}
        {presetCollapse({ icon: <ViewModuleIcon />, label: "ActiveModules" }, content.modules, 'modules')}
        <ListItem>
            <Row style={{ width: '100%', margin: '5px 0px' }}>
                <Col className="col-2 text-left secondary-text ">
                    <EventAvailableIcon />
                </Col>
                <Col className="col-8 text-left secondary-text" style={{ padding: '2px' }}>
                    <SystemLabel name={"Agenda"} />
                </Col>
                <Col className="col-2 text-right primary-text" >
                    {content.agenda ? <React.Fragment><SystemLabel name="Dot" /> {content.agenda.sortOrder + 1}</React.Fragment> : <SystemLabel name="None" />}
                </Col>
            </Row>

        </ListItem>
        <ListItem>
            <Row style={{ width: '100%', margin: '5px 0px' }}>
                <Col className="col-2 text-left secondary-text ">
                    <LiveTvIcon />
                </Col>
                <Col className="col-8 text-left secondary-text " style={{ padding: '2px' }}>
                    <SystemLabel name={"PresenterQuestoin"} />
                </Col>
                <Col className="col-2 text-right primary-text" >
                    {content.presenter ? content.presenter.name : <SystemLabel name="None" />}
                </Col>
            </Row>
        </ListItem>
    </List>
    return contentInfo;
}


function presetCollapse(summery, details, type) {
    return <ExpansionPanel className="dark-card" style={{ padding: '0px 13px' }}>
        <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon className="primary-text" />}
            disabled={(details.length === 0)}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="dark-card"
            style={{
                display: 'inline-flex',
                padding: '0px',
                width: '100%'
            }}
        >
            <Row style={{ width: '100%' }}>
                <Col className="col-2 text-left secondary-text ">
                    {summery.icon}
                </Col>
                <Col className="col-8 text-left secondary-text">
                    <SystemLabel name={summery.label} />
                </Col>
                <Col className="col-2 text-left primary-text" >
                    {type === 'modules' ? details.filter(d => d.visible === true).length : details.length}
                </Col>
            </Row>

        </ExpansionPanelSummary>
        <AccordionDetails style={{ display: 'inline-block', width: '100%', padding: '10px 0px' }}>
            {details.map((d, i) => {
                return type === 'modules' ? (
                    <Row key={i}>
                        <Col className="col-2 text-left secondary-text">

                        </Col>
                        <Col className="col-8 text-left" style={{ padding: '0px' }}>
                            <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.label || d.name}</Typography>
                        </Col>
                        <Col className="col-2 text-right">
                            <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.visible ? <SystemLabel name="Visible" /> : null}</Typography>
                        </Col>
                    </Row>
                ) :
                    (
                        <Row key={i} tyle={{ width: '100%' }}>
                            <Col className="col-2 text-left secondary-text">
                                <ListItemAvatar className="">
                                    {i + 1}
                                </ListItemAvatar>
                            </Col>
                            <Col className="col-8 text-left" style={{ padding: '0px' }}>
                                <Typography className="primary-text" style={{ marginLeft: '10px' }}>{d.label || d.name}</Typography>
                            </Col>
                            <Col className="col-2 text-right">

                            </Col>
                        </Row>
                    )
            })}

        </AccordionDetails>
    </ExpansionPanel>
}